// Single source of truth for route/menu role gating on the frontend.
// Mirrors the backend rbac.py AREA_ROLES so hidden menus (sidebar), denied URLs
// (ProtectedRoute), and 403 API responses all agree.
//
// owner and platform admins implicitly pass every check.

export const ROUTE_ROLES = {
  '/backoffice/accounting': ['owner', 'finance_manager'],
  '/finance/audit': ['owner', 'finance_manager'],
  '/backoffice/employees': ['owner', 'store_manager'],
  '/backoffice/branches': ['owner'],
  '/backoffice/inventory': ['owner', 'store_manager', 'inventory_manager'],
  '/backoffice/recipes': ['owner', 'store_manager'],
  '/backoffice/marketing': ['owner', 'marketing_crm'],
  '/backoffice/customers': ['owner', 'marketing_crm'],
  '/backoffice/report-scheduling': ['owner', 'store_manager'],
  '/backoffice/kitchen-stations': ['owner', 'store_manager'],
  '/backoffice/cash-management': ['owner', 'store_manager', 'finance_manager'],
  '/backoffice/reports-hub': ['owner', 'store_manager', 'finance_manager'],
  '/backoffice/outlet-settings': ['owner'],
  '/dashboard/menu': ['owner', 'store_manager'],
  '/dashboard/users': ['owner'],
  '/dashboard/outlets': ['owner'],
  '/dashboard/settings': ['owner'],
  '/finance/reports': ['owner', 'store_manager', 'finance_manager'],
  '/finance/bir-reports': ['owner', 'store_manager', 'finance_manager'],
  '/dashboard/promotions': ['owner', 'store_manager', 'marketing_crm'],
  '/backoffice/marketing': ['owner', 'marketing_crm'],
  // Operational screens — restrict direct-URL access to the roles that see them in the sidebar.
  '/pos': ['owner', 'store_manager', 'cashier'],
  '/kds': ['owner', 'store_manager', 'kitchen_staff'],
  '/backoffice/reservations': ['owner', 'store_manager', 'cashier'],
  '/backoffice/gift-cards': ['owner', 'store_manager', 'cashier'],
};

export function rolesForPath(pathname) {
  // Most-specific (longest) prefix wins.
  const keys = Object.keys(ROUTE_ROLES).sort((a, b) => b.length - a.length);
  const match = keys.find((k) => pathname === k || pathname.startsWith(k + '/'));
  return match ? ROUTE_ROLES[match] : null;
}

export function canAccess(roleName, pathname, isPlatformAdmin) {
  if (isPlatformAdmin) return true;
  const roles = rolesForPath(pathname);
  if (!roles) return true; // unlisted routes are open to any authenticated user
  return roles.includes(roleName);
}
